import { useEffect } from "react";
import React from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { useMaterialUIController, setLayout } from "context";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, darkMode } = controller; // <-- pega o darkMode
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: "relative",
        minHeight: "100vh",

        // fundo base (claro no light, sólido no dark)
        backgroundColor: darkMode ? "#0F1115" : "#F7FAFC",

        // aplica o degradê apenas no tema claro
        ...(darkMode
          ? {}
          : {
              "&::before": {
                content: '""',
                position: "absolute",
                inset: 0,
                height: { xs: 240, md: 300 }, // altura do topo “azul clarinho”
                background: "linear-gradient(180deg, #D6F0FF 0%, #F7FAFC 100%)",
                zIndex: 0,
              },
            }),

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {/* conteúdo acima do pseudo-elemento */}
      <MDBox sx={{ position: "relative", zIndex: 1 }}>{children}</MDBox>
    </MDBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
